import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class SelectVehicleWidget extends ReactiveWidget  {
  bind() {

  }

  render() {
    loadSelectInput.call(this)
  }
}

var loadSelectInput = function() {

  // this.selectForm = this.root.find(`${this.state.selector}`)

  $(`${this.state.selector}`).select2({
    placeholder: 'Search for Vehicle',
    minimumInputLength: 1,
    ajax: {
      url: '/select_data/vehicles',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true,
    }});
}

export default SelectVehicleWidget
